import { gql } from "lib/apolloClient";

/**
 * Phase 1: Fetch member IDs for given curriculum programs.
 * No pagination — fetches all IDs at once.
 */
export const getCalendarEventItemUsersQuery = gql`
  query getCalendarEventItemUsers(
    $organizationId: ID!
    $filters: CalendarEventItemUsersFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        calendarEventItemUsers(filters: $filters) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * Phase 2: Batch fetch member details by IDs.
 * Fields selected to support getFormattedUserName utility.
 */
export const getMemberDetailsByIdsQuery = gql`
  query getMemberDetailsByIds($memberIds: [ID!]) {
    multiNode(ids: $memberIds, type: USER) {
      id
      ... on User {
        firstName
        lastName
        middleName
        type
        profileImage
        studentAdditionalInfos {
          fieldUid
          value
        }
      }
    }
  }
`;

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades($id: ID!, $filters: GradeFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        grades(filters: $filters) {
          id
          name
          curriculumProgram {
            id
          }
        }
      }
    }
  }
`;

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses($id: ID!, $filters: CourseFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        courses(filters: $filters) {
          edges {
            node {
              id
              title
              curriculumProgram {
                id
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * Fetches member counts for given curriculum programs, grouped by school.
 */
// @2D-CALENDAR-TODO add family member count field here once backend merge
export const getOrganizationMemberCountsQuery = gql`
  query getOrganizationMemberCounts($organizationId: ID!) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        curriculumPrograms {
          id
          students {
            totalCount
          }
          staff {
            totalCount
          }
          familyMembers {
            totalCount
          }
        }
      }
    }
  }
`;
